import { render, staticRenderFns } from "./v-modal.vue?vue&type=template&id=755ddf5b&"
import script from "./v-modal.vue?vue&type=script&lang=js&"
export * from "./v-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports